import React from 'react';

// TITLES
const FormTitle = ({ children }) => (
  <h3 data-testid="app-form-title" className="form__title">
    {children}
  </h3>
);

export default FormTitle;
